const MyProfileRoutes = [
  {
    path: '/minha-conta',
    meta: { title: 'Minha Conta' },
    name: 'MyAccount',
    component: () => import('@/views/admin/myProfile/myProfile.vue'),
  }
]
export default MyProfileRoutes
